import React from 'react';
import { rescueHtml } from '../Components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page5MoyensMisEnOeuvre_Operations = (props) => {
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);

    const FieldBoxLargeTop = ({label}) => (
        <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: greyChapter, width: '30%', borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
            <p style={{marginTop: (0-props.marge), marginLeft: 5, fontSize: fontsize+2, lineHeight: 1.2}}>{label}</p>
        </div>
    );

    const ValueBoxLargeTop = ({value}) => (
        <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: greyclair, width: '70%', borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
            <p style={{marginTop: (0-props.marge), marginLeft: 5, fontSize: fontsize+2, lineHeight: 1.2, whiteSpace: 'normal', wordWrap: 'break-word', height: 60, overflowY: 'hidden'}}>{value || ''}</p>
        </div>
    );

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '20%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Moyens mis en oeuvre</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{props.operation.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '10px 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '10px'}}>
                
                {/* Ligne 1: Ressources humaines */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Ressources humaines" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.ressources_humaines || '')} />
                </div>

                {/* Ligne 2: Études */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Études" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.etudes || '')} />
                </div>

                {/* Ligne 3: Outils, matériels */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Outils, matériels" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.outils || '')} />
                </div>

                {/* Ligne 4: Investissements */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Investissements" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.investissements || '')} />
                </div>

                {/* Ligne 5: Incidences organisationnelles */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Incidences organisationnelles" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.incidences_orga || '')} />
                </div>

            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page5MoyensMisEnOeuvre_Operations;
